// ============================================================================
// File: src/modules/ppe/pages/procurement/dashboard/components/layout/AnalyticsCard.jsx
// Purpose: Standard analytics container for charts (Enterprise Version)
// ============================================================================

import React from "react";
import "./analyticsCard.css";

export default function AnalyticsCard({
  title,
  subtitle,
  children,
  rightAction
}) {
  return (
    <div className="analytics-card">

      {/* Header */}
      <div className="analytics-header">

        <div className="analytics-header-left">
          <div className="analytics-title">{title}</div>

          {subtitle && (
            <div className="analytics-subtitle">
              {subtitle}
            </div>
          )}
        </div>

        {rightAction && (
          <div className="analytics-header-right">
            {rightAction}
          </div>
        )}

      </div>

      {/* Body */}
      <div className="analytics-body">
        {children}
      </div>

    </div>
  );
}
